<span>{{ currentValue }}</span>
